import { Scroll } from "@lib/scroll";

// history.scrollRestoration = "manual";

class _App {
  private scroll = Scroll;

  constructor() {
    console.log("App constructor");
  }
}

export const App = new _App();
